module.exports = __webpack_public_path__ + "static/media/FireSafePlus.00ed386d.svg";